<template>
  <li class="bar__li">
    <a
      ref="anchor"
      href="#"
      :class="buttonClass"
    ><span><slot /></span></a>
    <slot name="block" />
  </li>
</template>

<script>
export default {
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    dataset: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    Object.entries(this.dataset)
      .forEach(([key, value]) => {
        this.$refs.anchor.dataset[key] = value;
      });
  },
};
</script>

<style>

</style>
